import styled from 'styled-components';

export const Message = styled.span`
  font-weight: 400;
  color: ${({ theme }) => theme.palette.neutral.dark};
`;

export const WrapperBtn = styled.div`
  margin-bottom: 8px;
`;
